module.exports = __webpack_public_path__ + "static/media/line 2.28b3f07d.png";